module.exports = __webpack_public_path__ + "fonts/48f000e70e1b2fb298366e39c349500d.eot";